import { Dialog, DialogProps } from "../../../core/components/dialog";
import { DropDownList } from "../../../core/components/dropDownList";
import { FieldInstance } from "../../../core/components/field";
import { Config } from "../../../core/config/config";
import { ComponentHelper } from "../../../core/util/componentHelper";
import { Helper } from "../../../core/util/helper";
import { NotificationHelper } from "../../../core/util/notificationHelper";
import { Baraus } from "../cashExpense";
import React from "react";
import ReactDOM from "react-dom";

export const OpenCopyCashExpenseDialog = (sourceBaraus: Baraus) => {
    return new Promise<Baraus>((resolve) => {
        const targetElement = $("<div>");
        const props: any = {
            onOk: (baraus: Baraus) => {
                resolve(baraus)
            },
            onCancel: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            },
            baraus: sourceBaraus
        }
        $("body").append(targetElement);
        ReactDOM.render(<CopyCashExpenseDialog {...props} />, targetElement[0]);
    })
}

class CopyCashExpenseDialog extends React.Component<{
    onOk: (baraus: Baraus) => void;
    onCancel: () => void;
    baraus: Baraus;
}, {
    newIdBaraus: number;
}>{
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this.check()) {
                        this.onOk();
                    }
                    else {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("Field.Barauslage.AlreadyExists"));
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    private check = () => {
        return this.props.baraus?.IdBaraus != this.state?.newIdBaraus;
    }

    constructor(props) {
        super(props);
        this.state = {
            newIdBaraus: null
        }
    }

    private onOk = () => {
        let newBaraus: Baraus = JSON.parse(JSON.stringify(this.props.baraus));
        newBaraus.IsNew = true;
        newBaraus.IdBaraus = this.state.newIdBaraus;
        newBaraus.IsGuid = null;
        this.props.onOk(newBaraus);
    }

    private createDropDown = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.value = this.state.newIdBaraus;
        props.field.refreshDSOnRefChange = true;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.dataSourceUrl = "GeneralSettingsCashExpenses/GetDistinctBarausIds";
        props.field.optionLabel = Helper.getTranslation("WebSMS.ResourcePlanningScheduler.FilterTemplates.Default");
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.setState({ newIdBaraus: dataItem.Key });
        }
        props.onDataLoaded = (field: { model: string }, data: any) => {
        }
        return (
            <FieldInstance label={Helper.getTranslation("Field.Barauslage.IdMainGroup")} noHover={true} labelStyle={{ width: "auto" }}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    render() {
        return (<>
            <div>
                <Dialog {...this._dialogProps} open={true}>
                    {this.createDropDown()}
                </Dialog>
            </div>
        </>)
    }
}